import {buildQueryParams} from "../../utils";
import {useApi} from "../Api";
import {
    ExcessGroupAssociationRequest,
    ExcessGroupEntityRequest,
    ExcessGroupEntityResponse,
    FormSearchExcessGroupModel
} from "../types/excessGroup";
import {ExcessGroupNewDetail} from "../types/excessGroupDetail";
import {PagedResponse} from "../types/pagination";
import {SelectElementModelFE} from "../types/generic";

export const useExcessGroupRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/excess-group";

    function getExcessGroup(excessGroupId: number): Promise<ExcessGroupEntityResponse> {
        return GET(`${PATH}?id=${excessGroupId}`);
    }

    function getExcessGroupsByCommercialCategoryId(commercialCategoryId: string, dealers: string,
                                                   legalEntities: string): Promise<ExcessGroupEntityResponse[]> {
        return GET(`${PATH}/excess-groups-by-commercial-category?commercialCategoryId=${commercialCategoryId}&dealers=${dealers}&legalEntities=${legalEntities}`);
    }

    function putExcessGroup(excessGroup: ExcessGroupEntityResponse): Promise<ExcessGroupEntityResponse> {
        return PUT(`${PATH}`, excessGroup);
    }

    function deleteExcessGroup(excessGroupId: number): Promise<number> {
        return DELETE(`${PATH}?id=${excessGroupId}`);
    }

    function terminateExcessGroup(excessGroupId: number): Promise<ExcessGroupEntityResponse> {
        return GET(`${PATH}/terminate?id=${excessGroupId}`);
    }

    function getExcessGroupsPaged(filters: FormSearchExcessGroupModel): Promise<PagedResponse<ExcessGroupEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function getExcessGroupsPagedProductPlan(filters: any): Promise<PagedResponse<ExcessGroupEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter/get-valid-excess-group${queryParams ? query + queryParams : ""}`);
    }

    function postExcessGroup(excessGroupList: ExcessGroupEntityRequest): Promise<ExcessGroupEntityResponse> {
        return POST(`${PATH}`, excessGroupList);
    }

    function isExcessGroupInUse(excessGroupId: number): Promise<boolean> {
        return GET(`${PATH}/in-use?excessGroupId=${excessGroupId}`);
    }

    function updateExcessMatrix(associationRequest: ExcessGroupAssociationRequest): Promise<ExcessGroupNewDetail> {
        return PUT(`${PATH}/update-excess-matrix`, associationRequest);
    }

    function getExcessGroupPlan({
                                    productCode,
                                    locationGroup
                                }: { productCode: string, locationGroup: number }): Promise<ExcessGroupEntityResponse[]> {
        return GET(`${PATH}/excess-groups-by-product-code-location-group?productCode=${productCode}&locationGroup=${locationGroup}`);
    }

    return {
        getExcessGroup,
        getExcessGroupsByCommercialCategoryId,
        getExcessGroupsPaged,
        postExcessGroup,
        putExcessGroup,
        deleteExcessGroup,
        isExcessGroupInUse,
        updateExcessMatrix,
        terminateExcessGroup,
        getExcessGroupsPagedProductPlan
    };
};
